document.addEventListener('DOMContentLoaded', function() {
    const menu1 = document.querySelector('.menu1');
    const menu1Trigger = document.querySelector('.menu1-mobile-trigger');
    const menu1Close = document.querySelector('.menu1-mobile-close');
    const menu1Overlay = document.querySelector('.overlay');

    // Toggle the main menu1 visibility
    function togglemenu1() {
        menu1.classList.toggle('active');
        menu1Overlay.classList.toggle('active');
    }

    // Show the submenu1 for a given parent menu1 item
    function showSubmenu1(parentmenu1Item) {
        const submenu1 = parentmenu1Item.querySelector('.menu1-subs');
        if (submenu1) {
            submenu1.classList.add('active');
            submenu1.style.animation = 'slideLeft 0.5s ease forwards';
            const menu1Title = parentmenu1Item.querySelector('i').previousSibling.textContent;
            menu1.querySelector('.menu1-mobile-title').textContent = menu1Title;
            menu1.querySelector('.menu1-mobile-header').classList.add('active');
        }
    }

    // Hide the currently active submenu1
    function hideSubmenu1() {
        const activeSubmenu1 = menu1.querySelector('.menu1-subs.active');
        if (activeSubmenu1) {
            activeSubmenu1.style.animation = 'slideRight 0.5s ease forwards';
            setTimeout(() => {
                activeSubmenu1.classList.remove('active');
            }, 500); // Match the animation duration
            menu1.querySelector('.menu1-mobile-title').textContent = '';
            menu1.querySelector('.menu1-mobile-header').classList.remove('active');
        }
    }

    // Event listeners for menu1 interactions
    menu1.addEventListener('click', function(e) {
        if (e.target.closest('.menu1-item-has-children')) {
            const hasChildren = e.target.closest('.menu1-item-has-children');
            showSubmenu1(hasChildren);
        }
    });

    document.querySelector('.menu1-mobile-arrow').addEventListener('click', hideSubmenu1);
    menu1Trigger.addEventListener('click', togglemenu1);
    menu1Close.addEventListener('click', togglemenu1);
    menu1Overlay.addEventListener('click', togglemenu1);

    // Adjust menu1 based on window resizing
    window.addEventListener('resize', function() {
        if (window.innerWidth > 991 && menu1.classList.contains('active')) {
            togglemenu1(); // Automatically hide the mobile menu1 on larger screens
        }
    });
});